var map = {
	"./1.svg": 3983,
	"./10.svg": 2768,
	"./11.svg": 225,
	"./12.svg": 5231,
	"./13.svg": 2645,
	"./2.svg": 1034,
	"./3.svg": 873,
	"./31.svg": 9678,
	"./32.svg": 7606,
	"./33.svg": 6003,
	"./34.svg": 5924,
	"./35.svg": 3483,
	"./36.svg": 5404,
	"./37.svg": 6668,
	"./38.svg": 4572,
	"./39.svg": 1298,
	"./4.svg": 7231,
	"./40.svg": 3541,
	"./41.svg": 8522,
	"./42.svg": 9082,
	"./43.svg": 8284,
	"./5.svg": 1829,
	"./6.svg": 4703,
	"./61.svg": 6642,
	"./62.svg": 2302,
	"./63.svg": 7117,
	"./64.svg": 4708,
	"./65.svg": 2658,
	"./66.svg": 7820,
	"./67.svg": 8338,
	"./68.svg": 949,
	"./69.svg": 3795,
	"./7.svg": 9474,
	"./70.svg": 6358,
	"./71.svg": 102,
	"./72.svg": 3849,
	"./73.svg": 1463,
	"./8.svg": 3110,
	"./81.svg": 311,
	"./82.svg": 371,
	"./83.svg": 81,
	"./84.svg": 7314,
	"./85.svg": 724,
	"./86.svg": 1632,
	"./87.svg": 7960,
	"./88.svg": 5830,
	"./89.svg": 955,
	"./9.svg": 369,
	"./90.svg": 3652,
	"./91.svg": 2801,
	"./92.svg": 1172,
	"./93.svg": 1170,
	"./noAnswer.svg": 3403,
	"./skip.svg": 9857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6810;